
import { Formik } from "formik";
import { Link, useNavigate, useParams } from "react-router-dom"

// import CustomDropdown from "../../../../../common/CustomDropdown";
import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import CustomInputField from "../../../common/CustomInputField";
import { addMainModule, clodinaryImage, updateMainModule, updateModule } from "../../../api/login/Login";


import Loadar from "../../../common/loader/Loader";
import { baseUrlImage } from "../../../baseUrl";
function AddMainModule() {

    const itemList = [
        { name: "Airtel", value: "Airtel" },
        { name: "Jio", value: "Jio" },
        { name: "VI", value: "VI" },
    ];
    const navigate = useNavigate()
    // const [image, setImage] = useState("");      // for local preview
    const [imageUrl, setImageUrl] = useState(""); // for uploaded URL

    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        const allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];
    
        if (!file) return;
    
        if (!allowedTypes.includes(file.type)) {
            toast.error("Invalid file type. Please select a JPEG, PNG, or GIF image.");
            return;
        }
    
        // const previewUrl = URL.createObjectURL(file);
        // setImage(previewUrl);
    
        try {
            const formData = new FormData();
            formData.append('image', file);
            let res = await clodinaryImage(formData);
    
            if (res?.data?.data?.url) {
                setTimeout(()=>{
                    setImageUrl(res.data.data.url);
                },500)
               
                toast.success("Image uploaded successfully!");
            } else {
                toast.error("Image upload failed. Please try again.");
            }
        } catch (error) {
            console.error('Image upload failed:', error);
            toast.error("Image upload failed. Please try again.");
        }
    };

    const [initialValues, setInitialValues] = useState({
        name: "",
        slug: '',
    });

    const params = useParams();


    // const validate = (values) => {
    //     let errors = {};
    //     if (!values.name) {
    //         errors.name = "Name is required";
    //     }

    //     if (!values.slug) {
    //         errors.slug = "slug is required";
    //     }


    //     return errors;
    // };
    const validate = (values) => {
        let errors = {};
        if (!values.name || values.name.trim().length < 4) {
            errors.name = "Name is require &Name must be at least 4 characters";
        }

        if (!values.slug || values.slug.trim().length < 4) {
            errors.slug = "Slug is require & Slug must be at least 4 characters";
        }

        return errors;
    };


    const toastSuccessMessage = () => {
        toast.success(`${params?.id ? "Update" : "Add"} Main Module successfully .`, {
            position: "top-center",
        });
    };

    // const curencyidget = async () => {
    //     try {
    //         const data = await getCountryAdd()
    //         setCombo(data?.data)

    //     } catch (error) {
    //         alert(error.message)
    //     }
    // }

    const [loader, setLoader] = useState(false)
    const submitForm = async (values) => {
        if(!imageUrl)
        {
            alert("Images is Required")
            return
        }
        console.log(values);
        setLoader(true)
        try {
            if (!params?.id) {
                try {
                    const res = await addMainModule({ ...values , module_img: imageUrl});
                    if (res?.statusCode == "200") {
                        toastSuccessMessage();
                        setTimeout(() => {
                            navigate('/admin/listMainModule')
                        }, [100])
                    }
                } catch (error) {

                }

            } else {
                try {
                    const res = await updateModule(params.id, { ...values , module_img: imageUrl });
                    if (res?.statusCode == "200") {
                        toastSuccessMessage();
                        setTimeout(() => {
                            navigate('/admin/listMainModule')
                        }, [100])
                    }
                } catch (error) {

                }
                finally {
                    setLoader(false);
                }

            }

        } catch (error) {
            console.error("Error:", error);
        }
        setLoader(false)
    };

    useEffect(() => {
        // curencyidget()
    }, [])

    useEffect(() => {
        const fetchCurrency = async () => {
            try {
                if (params?.id) {
                    const response = await updateMainModule(params.id);
                    const currencyData = response.data;
                    setInitialValues(currencyData);
                    setImageUrl(currencyData?.module_img)
                } else {
                    // setInitialValues({
                    //     name: "",
                    //     code: "",
                    //     curruncy_id: "",
                    // });
                }
            } catch (error) {
                console.error("Error fetching currency:", error);
            }
        };

        fetchCurrency();
    }, [params?.id]);
    return (
        <>
            {loader && <Loadar />}
            <Formik
                initialValues={initialValues}
                validate={validate}
                onSubmit={submitForm}
                enableReinitialize
                className="tbl-captionn"
            >
                {(formik) => {
                    const {
                        values,
                        handleChange,
                        handleSubmit,
                        errors,
                        touched,
                        handleBlur,
                        isValid,
                        dirty,
                    } = formik;
                    return (
                        <div className="row m-4" >
                            <div className="col-xl-12">
                                <div className="card">
                                    <div className="card-body p-0">
                                        <div className="table-responsive active-projects style-1">
                                            <div className="tbl-caption tbl-caption-2">
                                                <h4 className="heading mb-0">
                                                    {params?.id ? "UPDATE" : "ADD"} Main Module</h4>
                                            </div>
                                            <form className="tbl-captionn" onSubmit={handleSubmit}>
                                                <div className="row">
                                                    {/* <div className="col-xl-4 mb-3">
                                                        <select className="form-select" aria-label="Default select example" value={values.provider_name} name="provider_name" onChange={handleChange}>
                                                            <option selected>Open this select menu</option>
                                                            <option value={"Airtel"}>Airtel</option>
                                                            <option value={"Jio"}>Jio</option>
                                                            <option value={'VI'}>VI</option>
                                                        </select>

                                                    </div> */}
                      <div className="col-xl-4 mb-3">
    {/* <label className="form-label">Upload Image</label> */}
    <input
        type="file"
        className="form-control"
        accept="image/*"
        onChange={handleImageChange}
    />
    {imageUrl && (
        <div className="mt-2">
            <img
                src={`${baseUrlImage}${imageUrl}`}
                
                alt="Preview"
                style={{ width: '100px', height: '100px', objectFit: 'cover' }}
            />
        </div>
    )}
</div>

                                                    <div className="col-xl-4 mb-3">
                                                        <CustomInputField
                                                            type="text"
                                                            placeholder="Enter Name "
                                                            value={values.name}
                                                            hasError={errors.name && touched.name}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            errorMsg={errors.name}
                                                            autoFocus={true}
                                                            id="name"
                                                        />
                                                    </div>

                                                    <div className="col-xl-4 mb-3">
                                                        <CustomInputField
                                                            type="text"
                                                            placeholder="Enter Slug "
                                                            value={values.slug}
                                                            hasError={errors.slug && touched.slug}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            errorMsg={errors.slug}
                                                            autoFocus={true}
                                                            id="slug"
                                                        />
                                                    </div>
                              


                                                    <div className="col-12 mb-3">
                                                        <Link to='/admin/listMainModule' className="btn btn-danger light ms-1">Cancel</Link>
                                                        <button
                                                            className="btn btn-primary me-1"
                                                            type="submit"
                                                            disabled={!isValid}
                                                        >
                                                            {loader ? (
                                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                            ) : (
                                                                params?.id ? "Update" : "Add"
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>

                                            </form>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                }}
            </Formik>
            <ToastContainer />
        </>
    )
}
export default AddMainModule